import Vue from 'vue';

// String filter
import { truncate, uppercase } from 'vue-string-filter';

// Library to deal with numbers
const numeral = require('numeral');

// DayJS
import dayjs from 'dayjs';
const relativeTime = require('dayjs/plugin/relativeTime');
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.tz.setDefault('Europe/London');
Vue.prototype.$dayjs = dayjs;

// Vue filters
Vue.filter('formatDate', function(value) {
    if(value) {
        const date = dayjs.isDayjs(value) ? value : dayjs(String(value));
        return date.format('DD/MM/YYYY');
    }
});

Vue.filter('formatDateTime', function(value) {
    if(value) {
        const date = dayjs.isDayjs(value) ? value : dayjs(String(value));
        const format = 'DD/MM/YYYY' + (date.hour() ? ' HH:mm' : '');
        return date.format(format);
    }
});

Vue.filter('timeAgo', function(value) {
    if(value) {
        const date = dayjs.isDayjs(value) ? value : dayjs(String(value));
        return date.fromNow();
    }
});

Vue.filter('currency', function(value, decimalPoints = 2) {
    value = value || 0;
    value = parseFloat(value);
    const format = '0,0' + (decimalPoints ? '.' : '') + ''.padStart(decimalPoints, '0');
    return numeral(value).format(format);
});

Vue.filter('withPoundSymbol', function(value) {
    if(! value) {
        return value;
    }
    return (Math.sign(parseFloat(value)) === -1 ? '-' : '') + '£' + value.replace('-', '');
});

Vue.filter('truncate', truncate);
Vue.filter('uppercase', uppercase);
